// extracted by mini-css-extract-plugin
export var columns = "footer-module--columns--c96e5";
export var container = "footer-module--container--23490";
export var flexLogos = "footer-module--flexLogos--fbf58";
export var logoImg = "footer-module--logoImg--574b1";
export var logoLink = "footer-module--logoLink--21dd8";
export var separator = "footer-module--separator--ce965";